import { render, staticRenderFns } from "./PadThicknessFieldWidget.vue?vue&type=template&id=44dd3c82"
import script from "./PadThicknessFieldWidget.vue?vue&type=script&lang=js"
export * from "./PadThicknessFieldWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports